// src/msal/authConfig.js
import { b2cPolicies } from "@/msal/b2cPolicies";
import { apiConfig } from "@/msal/apiConfig";
import { BrowserCacheLocation } from "@azure/msal-browser";

export const SPA_ORIGIN =
  (typeof window !== "undefined" && window.location.host.includes("localhost")
    ? "http://"
    : "https://") +
  (typeof window !== "undefined" ? window.location.host : "localhost");

export const SILENT_REDIRECT_URI = `${SPA_ORIGIN}/silent-redirect.html`;

// Static copy of the B2C policy's OpenID Connect metadata
// (https://precisionsportstech.b2clogin.com/precisionsportstech.onmicrosoft.com/B2C_1_Dashboard_Users/v2.0/.well-known/openid-configuration).
// MSAL normally fetches this over the network on every init to resolve the
// authorize/token/logout endpoints, and throws `endpoints_resolution_error`
// when that request can't complete - which happens for real users in
// network-restricted contexts (Apple Mail's link-prefetch sandbox, embedded
// WKWebViews, flaky mobile networks). Providing it statically lets MSAL skip
// that network round trip entirely. See
// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/authority.md#custom-authority-metadata
const B2C_AUTHORITY_METADATA = JSON.stringify({
  issuer:
    "https://precisionsportstech.b2clogin.com/1828196e-b814-43af-ba30-b18214138b6a/v2.0/",
  authorization_endpoint:
    "https://precisionsportstech.b2clogin.com/precisionsportstech.onmicrosoft.com/b2c_1_dashboard_users/oauth2/v2.0/authorize",
  token_endpoint:
    "https://precisionsportstech.b2clogin.com/precisionsportstech.onmicrosoft.com/b2c_1_dashboard_users/oauth2/v2.0/token",
  end_session_endpoint:
    "https://precisionsportstech.b2clogin.com/precisionsportstech.onmicrosoft.com/b2c_1_dashboard_users/oauth2/v2.0/logout",
  jwks_uri:
    "https://precisionsportstech.b2clogin.com/precisionsportstech.onmicrosoft.com/b2c_1_dashboard_users/discovery/v2.0/keys",
});

export const msalConfig = {
  auth: {
    clientId: "2f9aaa4e-3025-4f82-8cdc-c4fd3192108d",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    authorityMetadata: B2C_AUTHORITY_METADATA,
    redirectUri: `${SPA_ORIGIN}/auth-redirect`,
    postLogoutRedirectUri: `${SPA_ORIGIN}/post-logout`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const loginRequest = {
  scopes: ["openid", "offline_access", ...apiConfig.b2cScopes],
  redirectUri: `${SPA_ORIGIN}/auth-redirect`,
};

export const silentLoginRequest = {
  ...loginRequest,
  redirectUri: SILENT_REDIRECT_URI,
};

export const tokenRequest = {
  scopes: [...apiConfig.b2cScopes],
  forceRefresh: false,
  redirectUri: `${SPA_ORIGIN}/auth-redirect`,
};

export const silentTokenRequest = {
  ...tokenRequest,
  redirectUri: SILENT_REDIRECT_URI,
};
